import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class AuditTrailDialogService {
    open$: Subject<any> = new Subject<any>();
}
